import moment from "moment";
import { formatDateTime, formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";
import { useNavigate } from "react-router-dom";
import { CustomTableRowTR, TableData } from "../../styles/commonStyles";
import { Button, Card, Chip, MenuItem, Select} from "@mui/material";
import CallButton from "../Common/CallButton/CallButton";
import { UserType } from "../../enums/common";
import { CustomButton } from "../OneMealService/OneMealServiceShow";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import { OneMealService } from "../../services/OneMealService";
import { CookService } from "../../services/CookServices";
import { useState } from "react";
import UpdateCommentInTrialDialog from "../Common/UpdateCommentInTrialDialog";
import UpdateCommentInChefForParty from "../Common/UpdateCommentInChefForParty";
import BoltIcon from '@mui/icons-material/Bolt';
import { colors } from "../../styles/colors";

let oneMealService = new OneMealService();
let cookService = new CookService()

export enum TrackingNotesEnum {
  ON_TIME = "On Time",
  DELAYED_5_MIN = "Delayed (5 minutes)",
  DELAYED_10_MIN = "Delayed (10 minutes)",
  DELAYED_15_MIN = "Delayed (15 minutes)",
  DELAYED_20_MIN = "Delayed (20 minutes)",
  DELAYED_25_MIN = "Delayed (25 minutes)",
  DELAYED_30_MIN = "Delayed (30 minutes)",
  DELAYED_35_MIN = "Delayed (35 minutes)",
  DELAYED_40_MIN = "Delayed (40 minutes)",
  DELAYED_45_MIN = "Delayed (45 minutes)",
  DELAYED_50_MIN = "Delayed (50 minutes)",
  DELAYED_55_MIN = "Delayed (55 minutes)",
  DELAYED_60_MIN = "Delayed (1 hour)",
  COOK_DENIED = "Cook Denied",
  COOK_HAS_GENUINE_EMERGENCY = "Cook Has Genuine Emergency",
  COOK_APPLIED_LEAVE = "Cook Applied Leave",
  COOK_DNP1 = "Cook DNP1",
  COOK_DNP2 = "Cook DNP2",
  COOK_DNP3 = "Cook DNP3",
  COOK_DNP4 = "Cook DNP4",
  COOK_DNP5 = "Cook DNP5",
  PRE_CHECKIN_ON_TIME = "Pre Check-in On Time",
  CALLED_PERSONALLY = "Called Personally",
}

export enum TrackingStatusEnum {
  TRACKED_ON_TIME = 'Tracked On Time',
  DELAYED_TRACKING = 'Delayed Tracking',
  NO_CALL_DONE = 'No Call Done',
  TO_BE_TRACKED = 'To Be Tracked',
  TRACKING_NOT_DONE = 'Tracking Not Done'
}

export function getChipColors(status: string) {
  switch (status) {
    case "Tracked On Time":
      return { backgroundColor: "green", color: "white" };
    case "Delayed Tracking":
      return { backgroundColor: "yellow", color: "black" };
    case "No Call Done":
      return { backgroundColor: "red", color: "white" };
    default:
      return { backgroundColor: "#E0E0E0", color: "#000000" };
  } 
}

const VisitTrackerList = ({
  eachData,
  onDataChange,
}: {
  eachData: any;
  onDataChange?: () => Promise<void> | void;
}) => {
  const navigate = useNavigate();

  let [openPartyCommentDialog, setOpenPartyCommentDialog] = useState(false);
  let [openOneMealDialog, setOpenOneMealDialog] = useState(false);
  const lastVisitedId = sessionStorage.getItem("lastVisitedTrackerId");

  let verifyOldVisit = (eachData: any) => {
    if(eachData?.referenceModelName === "CHEF_FOR_PARTY") {
      const arrivalTime = moment(eachData?.visitData?.ChefForPartyCookDetailsModels[0]?.arrivalTime);
      const currentTime = moment();
      if(currentTime.isAfter(arrivalTime) && !eachData?.visitData?.ChefForPartyCookDetailsModels[0]?.checkInTime) {
        return true;
      }
    }
    else if(eachData?.referenceModelName === "ONE_MEAL_SERVICE") {
      const visitDateTime = moment(moment(eachData?.visitData?.date).format("YYYY-MM-DD") + " " + eachData?.visitData?.time);
      const currentTime = moment();
      if(currentTime.isAfter(visitDateTime) && !eachData?.visitData?.checkInTime) {
        return true;
      }
    }
    return false;
  }
  
const cookId =
  eachData?.referenceModelName === "ONE_MEAL_SERVICE"
    ? eachData?.visitData?.cookId
    : eachData?.visitData?.ChefForPartyCookDetailsModels?.find(
        (cook: any) => cook?.type === "MAIN_CHEF"
      )?.cookId
  
  return (
    <CustomTableRowTR
      key={eachData.id}
      onClick={() => {
            sessionStorage.setItem(
              "lastVisitedTrackerId",
              String(eachData?.visitData?.id)
            );
            navigate(`/VisitTracker/${eachData.referenceModelName}/${eachData?.visitData?.id}/${cookId}`, {
              state: { visitData: eachData?.visitData },
            });
          }}
      sx={{
        backgroundColor:
        verifyOldVisit(eachData) ? "#E97451 !important" :
          eachData?.visitData?.isImportant ? "#FFD700 !important" :
          Number(lastVisitedId) === eachData?.visitData?.id
            ? "#FCF55F !important" // highlighted color
            : eachData?.isFirstVisit
            ? "skyblue !important"
            : 'transparent',
        cursor: "pointer",
        padding: "8px 0 !important",

        "&:hover": {
          backgroundColor:
          verifyOldVisit(eachData) ? "#E97451 !important" :
          eachData?.visitData?.isImportant ? "#FFD700 !important" :
          Number(lastVisitedId) === eachData?.visitData?.id
            ? "#FCF55F !important" // highlighted color
            : eachData?.isFirstVisit
            ? "skyblue !important"
            : 'transparent',
        }
      }}
    >
      <TableData style={{display: 'flex', flexDirection: 'column'}}>{eachData?.referenceModelName === "ONE_MEAL_SERVICE" ?
        <CustomButton
            name={(eachData?.visitData as any)?.allowLateCheckIn ? "Remove Late Checkin" : "Allow Late Checkin"}
            color="success"
            callback={() => {
              EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                message: (eachData?.visitData as any)?.allowLateCheckIn ? "Are you sure you want to remove late checkin?" : "Are you sure you want to allow late checkin?",
                onClose: (confirmed: boolean) => {
                  if (confirmed) {
                    oneMealService
                      .allowLateCheckin(parseInt((eachData?.visitData as any)?.id))
                      .then(() => {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Allowed late checkin",
                          type: CustomSnackbarTypes.SUCCESS,
                        });
                        onDataChange?.();
                      });
                  }
                },
                title: "Confirmation",
              });
            }}
          /> : 'Not Applicable'}
        <Button
            variant="contained"
            size="small"
            style={{
              marginTop: '16px', fontSize: '12px', width: '100%'
            }}
            onClick={(e) => {
              // open add comment dialog / handler
              e.stopPropagation();
              eachData?.referenceModelName === "CHEF_FOR_PARTY"
                ? setOpenPartyCommentDialog(true)
                : setOpenOneMealDialog(true);
            }}
          >
            Add Comment
          </Button>
          </TableData>
      <TableData>
        {
          <Card
            style={{
              overflow: "auto",
              borderRadius: "4px",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 1px 3px",
              width: "20vw",
              padding: "8px",
              paddingBottom: "8px", // 👈 space for button
              position: "relative", // 👈 REQUIRED
            }}
        >
          {
            eachData?.referenceModelName === "CHEF_FOR_PARTY" ?  (eachData?.visitData?.allocatorComments?.length ? (
              eachData?.visitData?.allocatorComments.map((comment: any, index: number) => (
                <div key={index} style={{ marginBottom: "8px" }}>
                  <strong>{comment.commenterEmail}</strong>
                  <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div style={{ fontSize: "1em", color: "black" }}>{comment.comment}</div>
                    <div style={{ fontSize: "1em", color: "black", whiteSpace: 'nowrap' }}>
                      {formatDateTimeWithSeconds(comment.timestamp)}
                    </div>
                  </div>
                  <hr />
                </div>
              ))
            ) : (
              <div>Not Available</div>
            )) :
            (eachData?.visitData?.allocationComments?.length ? (
              eachData?.visitData?.allocationComments.map((comment: any, index: number) => (
                <div key={index} style={{ marginBottom: "8px" }}>
                  <strong>{comment.commenterEmail}</strong>
                  <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div style={{ fontSize: "1em", color: "black" }}>{comment.comment}</div>
                    <div style={{ fontSize: "1em", color: "black", whiteSpace: 'nowrap' }}>
                      {formatDateTimeWithSeconds(comment.timestamp)}
                    </div>
                  </div>
                  <hr />
                </div>
              ))
            ) : (
              <div>Not Available</div>
            ))}
        </Card>        
        }
      </TableData>   
      <TableData>
        <Select
          size="small"
          displayEmpty
          onClick={(e) => e.stopPropagation()} 
          value={eachData?.visitData?.trackingNotes ?? ""}
          onChange={(e) => {
            e.stopPropagation()
            const selectedNote = e.target.value as TrackingNotesEnum;
            cookService
              .updateTrackerNotes(
                Number(eachData?.visitData?.id),
                eachData?.referenceModelName,
                selectedNote
              )
              .then(() => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: "Tracking note updated successfully",
                  type: CustomSnackbarTypes.SUCCESS,
                });
                onDataChange?.();
              })
              .catch(() => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: "Failed to update tracking note",
                  type: CustomSnackbarTypes.ERROR,
                });
              });
          }}
          sx={{ width: "100%" }}
        >
          <MenuItem value="" disabled>
            Select Note
          </MenuItem>

          {Object.values(TrackingNotesEnum).map((note) => (
            <MenuItem key={note} value={note}>
              {note}
            </MenuItem>
          ))}
        </Select>
      </TableData>

      <TableData >

        <span style={{ fontWeight: 500, display: 'flex', alignItems: 'center' }}>

          {eachData?.visitData?.id} - {" "}

          <Chip
          label={
            eachData?.referenceModelName === "ONE_MEAL_SERVICE"
              ? "Chefit"
              : "Party"
          }
          size="small"
          sx={{
            height: "22px",
            fontSize: "11px",
            fontWeight: 600,
            borderRadius: "12px",
            px: 0.75,
            backgroundColor:
              eachData?.referenceModelName === "ONE_MEAL_SERVICE"
                ? "#ed6c02"
                : "#800080",
            color:
              eachData?.referenceModelName === "ONE_MEAL_SERVICE"
                ? "#fff"
                : "#fff",
          }}
        />

        {eachData?.visitData?.isInstantChefit && <BoltIcon sx={{color: "#FF9800", fontSize: 25}} />}
        </span>

        
      </TableData>
      <TableData style={{ textAlign: "center" }}>
        {eachData?.visitData?.paymentStatus && 
          <Chip
            label={
              eachData?.visitData?.paymentStatus
            }
            size="small"
            sx={{
              height: "22px",
              fontSize: "11px",
              fontWeight: 600,
              borderRadius: "12px",
              px: 0.75,
              backgroundColor:
                eachData?.visitData?.paymentStatus === "PAID"
                  ? colors.green
                  : "#D32F2F",
              color:
                eachData?.referenceModelName === "ONE_MEAL_SERVICE"
                  ? "#fff"
                  : "#fff",
            }} 
            />
        }
      </TableData>
      <TableData>{eachData?.visitData?.areaName} <br /> {eachData?.visitData?.cityName} <br />{eachData?.visitData?.localityName}</TableData>

      <TableData>
        <Chip
          label={eachData?.visitData?.trackingStatus}
          style={{
            backgroundColor:getChipColors(eachData?.visitData?.trackingStatus).backgroundColor,
            color: getChipColors(eachData?.visitData?.trackingStatus).color,
            fontWeight: 500,
            fontSize: "12px",
          }}
        />
      </TableData>
      <TableData>{eachData?.referenceModelName !== "CHEF_FOR_PARTY" ? eachData?.visitData?.cookName : eachData?.visitData?.ChefForPartyCookDetailsModels?.find(
        (cook: any) => cook?.type === "MAIN_CHEF"
      )?.cookName} </TableData>
      <TableData style={{zIndex: '100'}}>{ }
      <CallButton
            toPhoneNumber={eachData?.referenceModelName !== "CHEF_FOR_PARTY" ? eachData?.visitData?.cookPhoneNumber : eachData?.visitData?.ChefForPartyCookDetailsModels[0]?.cookPhone}
            userType={UserType.COOK}
            referenceId={Number(eachData?.visitData?.id)}
            referenceModelName={eachData?.referenceModelName}
          />
      </TableData>
      <TableData style={{ whiteSpace: 'nowrap' }}>
        {eachData?.referenceModelName !== "CHEF_FOR_PARTY" ? (eachData?.visitData?.isInstantChefit ? moment(eachData?.visitData?.cookArrivalTime).format("YYYY-MM-DD") : formatDateTime(moment(eachData?.visitData?.date).format("YYYY-MM-DD") + " " + eachData?.visitData?.time)) : formatDateTime(eachData?.visitData?.ChefForPartyCookDetailsModels[0]?.arrivalTime)}
      </TableData>
      <TableData style={{ whiteSpace: 'nowrap' }}>
        {eachData?.referenceModelName === "CHEF_FOR_PARTY" ? (eachData?.visitData?.ChefForPartyCookDetailsModels[0]?.preCheckedInAt ? formatDateTimeWithSeconds(eachData?.visitData?.ChefForPartyCookDetailsModels[0]?.preCheckedInAt) : "Not done yet" ) : (eachData?.visitData?.preCheckedInAt ? formatDateTimeWithSeconds(eachData?.visitData?.preCheckedInAt) : "Not done yet")}
      </TableData>
      <UpdateCommentInTrialDialog
          initiatedBy={8}
          open={openOneMealDialog}
          setOpen={setOpenOneMealDialog}
          omsId={Number(eachData?.visitData?.id)}
          onSuccess={onDataChange}
      />
      <UpdateCommentInChefForParty
        initiatedBy={1}
        data={eachData?.visitData}
        open={openPartyCommentDialog}
        setOpen={setOpenPartyCommentDialog}
        onSuccess={onDataChange}
      />
    </CustomTableRowTR>
  );
};
export default VisitTrackerList;
